const tmp: Vector3 = new window.v3d.Vector3();

export const parallelLines = (v1: Vector3, v2: Vector3) => {
  return tmp.copy(v1).cross(v2).length() < Number.EPSILON;
};
